var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 6.03317V16.2158L1 16.2158C1.08025 23.108 5.45774 29.2159 11.9587 31.5065L13.4533 32.0585V32.0585C14.4518 32.4252 15.5482 32.4252 16.5467 32.0585L18.0413 31.5065V31.5065C24.5423 29.2159 28.9197 23.108 29 16.2158V6.03316V6.03317C28.9973 5.21543 28.5074 4.47802 27.7547 4.1585L27.7547 4.1585C23.7157 2.4727 19.3764 1.6249 15 1.6665H15C10.6236 1.6249 6.28428 2.47271 2.24533 4.1585V4.1585C1.49259 4.47802 1.00274 5.21543 1 6.03317L1 6.03317Z",
    stroke: "#B7BABD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2636 13.3237H9.73637C9.32969 13.3237 9 13.6534 9 14.0601V23.2527C9 23.6594 9.32969 23.9891 9.73637 23.9891H20.2636C20.6703 23.9891 21 23.6594 21 23.2527V14.0601C21 13.6534 20.6703 13.3237 20.2636 13.3237Z",
    stroke: "#B7BABD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0007 20.408C15.9211 20.408 16.6673 19.6618 16.6673 18.7414C16.6673 17.8209 15.9211 17.0747 15.0007 17.0747C14.0802 17.0747 13.334 17.8209 13.334 18.7414C13.334 19.6618 14.0802 20.408 15.0007 20.408Z",
    stroke: "#B7BABD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 11.3241C18.3327 9.48311 16.8403 7.99072 14.9993 7.99072C13.1584 7.99072 11.666 9.48311 11.666 11.3241V13.3241H18.3327V11.3241Z",
    stroke: "#B7BABD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.63ac2da4d432e1d335db532791797e6b.svg";
export { ForwardRef as ReactComponent };